import { ROUTE_PREFIX } from "../src/constants";
import { PARK_PASS_IS_COMING } from '../../ui-pass/src/constants';

const childRoutes = [];

if (!PARK_PASS_IS_COMING) {
    // Order Details
    childRoutes[childRoutes.length] = {
        path: `${ROUTE_PREFIX}/order-details`,
        componentName: 'OrderDetailsPage',
        title: 'Order Details'
    };
}

export default childRoutes;